import axios from '@p/utils/request';
import api from '@/api';

//获取个人信息
export const getStaffInfo = () => {
	return axios.get(api.user.getStaffInfo)
}

//获取学习数据
export const getMyStudyData = () => {
	return axios.get(api.user.getMyStudyData)
}

//获取我的课程
export const getMyCourse = (data) => {
	return axios.get(api.user.getMyCourse,{params:data})
}

//获取我的教学
export const getMyTeach = (data) => {
	return axios.get(api.user.getMyTeach,{params:data})
}

//提交课程评价
export const evaluate = (data) => {
	return axios.post(api.user.evaluate,data)
}

//个人练习数据
export const getPracticeData = (data) => {
	return axios.get(api.user.getPracticeData,{params:data})
}

//已完成课程评分
export const getEvaluate = (data) => {
	return axios.get(api.user.getEvaluate,{params:data})
}